import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { FormBuilder } from "@jeremyling/react-material-ui-form-builder";
import Typography from "@mui/material/Typography";

const FormStepper = ({
    forms,
    defaultValue,
    methods,
    watch,
    mode,
    activeStep = 0,
    showHeader = true,
    isInline = false,
    arrStepFailed,
}) => {
    const isStepFailed = React.useCallback(
        (step) => {
            return arrStepFailed?.includes(step);
        },
        [arrStepFailed]
    );

    const labels = forms.map((form) => form.label);

    const formGroups = forms.map((form) => form.config);

    const defaultValues = React.useMemo(() => defaultValue, [defaultValue]);

    return (
        <Box>
            {showHeader && (
                <Stepper activeStep={activeStep}>
                    {labels.length > 1 &&
                        labels.map((label, index) => {
                            const labelProps = {};
                            if (isStepFailed(index)) {
                                labelProps.optional = (
                                    <Typography variant="caption" color="error">
                                        {}
                                    </Typography>
                                );
                                labelProps.error = true;
                            }
                            return (
                                <Step key={label}>
                                    <StepLabel {...labelProps}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                </Stepper>
            )}

            <Box
                sx={{
                    display: isInline ? "block" : "flex",
                    margin: "0 auto",
                    maxWidth: isInline ? "100%" : "sm",
                    justifyContent: "center",
                    alignSelf: "center",
                }}
            >
                {formGroups.map((formGroup, index) => (
                    <Box
                        sx={{ mt: 4 }}
                        key={`formGroup-${index}`}
                        style={{ display: activeStep === index ? "" : "none" }}
                    >
                        {activeStep === index && (
                            <FormBuilder
                                fields={formGroup(methods, watch, mode)}
                                defaultValue={defaultValues}
                                methods={methods}
                            />
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

FormStepper.propTypes = {
    forms: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            config: PropTypes.func.isRequired,
        })
    ).isRequired,
    defaultValue: PropTypes.object,
    methods: PropTypes.object.isRequired,
    watch: PropTypes.any,
    activeStep: PropTypes.number,
    mode: PropTypes.oneOf(["edit", "create"]),
    showHeader: PropTypes.bool,
    isInline: PropTypes.bool,
    arrStepFailed: PropTypes.arrayOf(PropTypes.number),
};

export default FormStepper;
